export default __webpack_public_path__ + "static/media/pumapay-business-console-logo.a3df34b3.png";